function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Space, Select, Drawer, Form, Input, Modal, notification, DatePicker } from 'antd';
import { Table } from 'react-bootstrap';
import { PencilSquare, HourglassSplit, EyeFill, CheckCircleFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import SaveMedicalQuestions from "../components/forms/SaveMedicalQuestions";
import SaveAudioData from "../components/forms/SaveAudioData";
import DisplayFile from "../components/DisplayFile";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
    Link = Typography.Link;

var Audio = function Audio() {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isDataLoading = _useState2[0],
      setIsDataLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      compList = _useState4[0],
      setCompList = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      compOptions = _useState6[0],
      setCompOptions = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      companyId = _useState8[0],
      setCompanyId = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      company = _useState10[0],
      setCompany = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      customers = _useState12[0],
      setCustomers = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      currentCustomer = _useState14[0],
      setCurrentCustomer = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      dataChanged = _useState16[0],
      setDataChanged = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showEditData = _useState18[0],
      setShowEditData = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      showDisplayData = _useState20[0],
      setShowDisplayData = _useState20[1];

  var _useState21 = useState(20),
      _useState22 = _slicedToArray(_useState21, 2),
      limit = _useState22[0],
      setLimit = _useState22[1];

  var _useState23 = useState(0),
      _useState24 = _slicedToArray(_useState23, 2),
      offset = _useState24[0],
      setOffset = _useState24[1];

  var _useState25 = useState("0"),
      _useState26 = _slicedToArray(_useState25, 2),
      keyword = _useState26[0],
      setKeyword = _useState26[1];

  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };

  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var handleCompanyChange = function handleCompanyChange(v) {
    setCompany(compList.filter(function (c) {
      return c.id == v;
    })[0]);
    setCompanyId(compList.filter(function (c) {
      return c.id == v;
    })[0].id);
    localStorage.setItem("defaultCompany", compList.filter(function (c) {
      return c.id == v;
    })[0].id);
  };

  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(HourglassSplit, {
        size: 24
      }), " CANDIDATS EN ATTENTE"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.audio_test_id == null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setCurrentCustomer(c);
                    setShowEditData(true);
                  },
                  children: [/*#__PURE__*/_jsx(PencilSquare, {
                    size: 22
                  }), " ", /*#__PURE__*/_jsx("b", {
                    children: " TRAITER"
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      }), " CANDIDATS TRAITES"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.audio_test_id != null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowEditData(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilSquare, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VOIR"
                    })]
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];

  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getaudioqueue"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        setCompanyId(response.data.companyList[0].id);
        setCompany(response.data.companyList[0]);

        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }

        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged, keyword, limit, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          children: [/*#__PURE__*/_jsx(Text, {
            mark: true,
            children: /*#__PURE__*/_jsx("b", {
              children: "#TESTE AUDIOMETRIE"
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form, {
            form: form,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "horizontal",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "comp",
                children: /*#__PURE__*/_jsx(Select, {
                  options: compOptions,
                  onChange: handleCompanyChange,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Input, {
                  onChange: handleKewordChange,
                  placeholder: "Code dossier"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Tabs, {
            items: items,
            animated: true,
            defaultActiveKey: 1
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx(Button, {
              loading: isDataLoading,
              type: "default",
              onClick: handleMore,
              children: /*#__PURE__*/_jsx("b", {
                children: "VOIR PLUS"
              })
            })
          })]
        })
      })]
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        open: showEditData,
        title: /*#__PURE__*/_jsx("b", {
          children: "ENTREZ LES DONNEES DE L'AUDIOMETRIE"
        }),
        width: 470,
        footer: null,
        onCancel: function onCancel() {
          setShowEditData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(SaveAudioData, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowEditData(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), currentCustomer.audio_test && /*#__PURE__*/_jsx(Drawer, {
        open: showDisplayData,
        title: /*#__PURE__*/_jsx("b", {
          children: "DETAILS"
        }),
        width: "80%",
        onClose: function onClose() {
          setShowDisplayData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(DisplayFile, {
          file_url: currentCustomer.audio_test.attached_file
        })
      })]
    })]
  });
};

export default Audio;